import { ChangeOfMajorIcon } from '@/assets/icons/change-of-major-icon'
import { CreditTransferIcon } from '@/assets/icons/credit-transfer-icon'
import { TransferIcon } from '@/assets/icons/transfer-icon'

export const REQUEST_TYPE = {
  EXTERNAL_TRANSFER: {
    id: '019a8378-4096-7be9-b493-596c8c01bbc3',
    icon: TransferIcon,
    name: 'Transferência Externa'
  },
  CHANGE_OF_MAJOR: {
    id: '019a8378-b142-7d52-9537-2c1bb441ea13',
    icon: ChangeOfMajorIcon,
    name: 'Troca de Curso'
  },
  CREDIT_TRANSFER: {
    id: '019a8378-723c-7215-84d2-a410b0f5721d',
    icon: CreditTransferIcon,
    name: 'Aproveitamento de Estudos'
  }
}
